import {ChangeEvent} from "react";
import {Path, PathValue, UseFormRegister, UseFormRegisterReturn, UseFormSetValue, UseFormWatch} from "react-hook-form";

/**
 * @deprecated use util from package `@pg-mono/react-hook-forms-utils`
 */
export const transformReactHookFormProps = (registerProps: UseFormRegisterReturn<string>) => {
    return {
        ...registerProps,
        onChange: (event: ChangeEvent<HTMLInputElement>) => {
            registerProps.onChange(event);
        }
    };
};

/**
 * @deprecated use util from package `@pg-mono/react-hook-forms-utils`
 */
export const transformReactHookFormToSelectProps = <CustomFieldValues extends Record<string, unknown>>(
    name: Path<CustomFieldValues>,
    registerFormValue: UseFormRegister<CustomFieldValues>,
    options: {value: string | number | boolean; label: string}[],
    watch: UseFormWatch<CustomFieldValues>,
    setValue: UseFormSetValue<CustomFieldValues>
) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const {ref, ...registerProps} = registerFormValue(name);
    // `value` prop on `input` should not be null. It is better to use an empty string to clear the component or `undefined` for uncontrolled components.
    const value = watch(name) || "";

    return {
        ...registerProps,
        // This ugly types and casting are due to the fact that for some reason when building in docker (docker image build -f apps/mp_crm/build/dockerfile .) types will fail here. This is why this is set to unknown. If refactoring please run docker build image first to check it is working fine or else you will discover issues when deploying on stage/production.
        onChange: (selectedOption: unknown, action: unknown) => {
            setValue(name, (selectedOption as {value: PathValue<CustomFieldValues, Path<CustomFieldValues>>}).value);
            registerProps.onChange({
                target: {
                    value: (selectedOption as {value: PathValue<CustomFieldValues, Path<CustomFieldValues>>}).value,
                    name: (action as {name: string})?.name
                }
            });
        },
        options,
        name,
        value: options.find((option) => option.value === value)
    };
};

/**
 * @deprecated use util from package `@pg-mono/react-hook-forms-utils`
 */
export const transformReactHookFormToMultiSelectProps = <CustomFieldValues extends Record<string, unknown>>(
    name: Path<CustomFieldValues>,
    registerFormValue: UseFormRegister<CustomFieldValues>,
    options: {value: string | number | boolean; label: string}[],
    watch: UseFormWatch<CustomFieldValues>,
    setValue: UseFormSetValue<CustomFieldValues>
) => {
    type OptionType = {value: string | number | boolean};
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const {ref, ...registerProps} = registerFormValue(name);
    const value = watch(name);

    return {
        ...registerProps,
        // This ugly types and casting are due to the fact that for some reason when building in docker (docker image build -f apps/mp_crm/build/dockerfile .) types will fail here. This is why this is set to unknown. If refactoring please run docker build image first to check it is working fine or else you will discover issues when deploying on stage/production.
        onChange: (selectedOption: unknown, action: unknown) => {
            const value = Array.isArray(selectedOption) ? (selectedOption as OptionType[]).map((option) => option.value) : [];

            setValue(name, value as PathValue<CustomFieldValues, Path<CustomFieldValues>>);
            registerProps.onChange({
                target: {
                    value: value,
                    name: (action as {name: string})?.name
                }
            });
        },
        options,
        name,
        value: options.filter((option) => (value as unknown as OptionType["value"][])?.includes(option.value))
    };
};

/**
 * @deprecated use util from package `@pg-mono/react-hook-forms-utils`
 */
export const useTransformReactHookFormToRadioProps = <CustomFieldValues extends Record<string, unknown>>(
    name: Path<CustomFieldValues>,
    register: UseFormRegister<CustomFieldValues>,
    watch: UseFormWatch<CustomFieldValues>,
    radioValue: string | boolean,
    setValue: UseFormSetValue<CustomFieldValues> // this would be better to set to generic however for some reason types on setValue are set to string, despite the fact it uses Path type
) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const {onBlur, ...registerProps} = register(name);
    const currentFormValue = watch(name); //this is returning current value of form. It will re-render all radio buttons connected to the same field updating their state;
    const isActive = currentFormValue === radioValue;

    return {
        ...registerProps,
        // eslint-disable-next-line  @typescript-eslint/no-explicit-any
        onChange: (name: Path<CustomFieldValues>, isChecked: boolean, value: any) => {
            const convertedValue = typeof radioValue === "boolean" ? "" : JSON.parse(value);

            /**
             * This is due to fact that clicking on input which is not the same as ref, correct value wont be registered and value will not be set when submitting.
             * Due to this fact setValue is used to set it programmatically. This is a ugly solution to avoid breaking radio button for other usages then use-react-hook ones.
             * Second reason is that by doing this we will only re render two inputs that are watching the same field value and not the whole form
             */
            setValue(name, convertedValue);

            registerProps.onChange({
                target: {
                    name,
                    value: radioValue
                }
            });
        },
        id: `${name}-${radioValue}`,
        name,
        isActive,
        value: radioValue as string
    };
};

/**
 * @deprecated use util from package `@pg-mono/react-hook-forms-utils`
 */
export const transformReactHookFormToTextAreaProps = (registerProps: UseFormRegisterReturn<string>) => {
    return {
        ...registerProps,
        onChange: (event: ChangeEvent<HTMLTextAreaElement>) => {
            registerProps.onChange(event);
        }
    };
};
import {ChangeEvent} from "react";
import {Path, PathValue, UseFormRegister, UseFormRegisterReturn, UseFormSetValue, UseFormWatch} from "react-hook-form";

/**
 * @deprecated use util from package `@pg-mono/react-hook-forms-utils`
 */
export const transformReactHookFormProps = (registerProps: UseFormRegisterReturn<string>) => {
    return {
        ...registerProps,
        onChange: (event: ChangeEvent<HTMLInputElement>) => {
            registerProps.onChange(event);
        }
    };
};

/**
 * @deprecated use util from package `@pg-mono/react-hook-forms-utils`
 */
export const transformReactHookFormToSelectProps = <CustomFieldValues extends Record<string, unknown>>(
    name: Path<CustomFieldValues>,
    registerFormValue: UseFormRegister<CustomFieldValues>,
    options: {value: string | number | boolean; label: string}[],
    watch: UseFormWatch<CustomFieldValues>,
    setValue: UseFormSetValue<CustomFieldValues>
) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const {ref, ...registerProps} = registerFormValue(name);
    // `value` prop on `input` should not be null. It is better to use an empty string to clear the component or `undefined` for uncontrolled components.
    const value = watch(name) || "";

    return {
        ...registerProps,
        // This ugly types and casting are due to the fact that for some reason when building in docker (docker image build -f apps/mp_crm/build/dockerfile .) types will fail here. This is why this is set to unknown. If refactoring please run docker build image first to check it is working fine or else you will discover issues when deploying on stage/production.
        onChange: (selectedOption: unknown, action: unknown) => {
            setValue(name, (selectedOption as {value: PathValue<CustomFieldValues, Path<CustomFieldValues>>}).value);
            registerProps.onChange({
                target: {
                    value: (selectedOption as {value: PathValue<CustomFieldValues, Path<CustomFieldValues>>}).value,
                    name: (action as {name: string})?.name
                }
            });
        },
        options,
        name,
        value: options.find((option) => option.value === value)
    };
};

/**
 * @deprecated use util from package `@pg-mono/react-hook-forms-utils`
 */
export const transformReactHookFormToMultiSelectProps = <CustomFieldValues extends Record<string, unknown>>(
    name: Path<CustomFieldValues>,
    registerFormValue: UseFormRegister<CustomFieldValues>,
    options: {value: string | number | boolean; label: string}[],
    watch: UseFormWatch<CustomFieldValues>,
    setValue: UseFormSetValue<CustomFieldValues>
) => {
    type OptionType = {value: string | number | boolean};
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const {ref, ...registerProps} = registerFormValue(name);
    const value = watch(name);

    return {
        ...registerProps,
        // This ugly types and casting are due to the fact that for some reason when building in docker (docker image build -f apps/mp_crm/build/dockerfile .) types will fail here. This is why this is set to unknown. If refactoring please run docker build image first to check it is working fine or else you will discover issues when deploying on stage/production.
        onChange: (selectedOption: unknown, action: unknown) => {
            const value = Array.isArray(selectedOption) ? (selectedOption as OptionType[]).map((option) => option.value) : [];

            setValue(name, value as PathValue<CustomFieldValues, Path<CustomFieldValues>>);
            registerProps.onChange({
                target: {
                    value: value,
                    name: (action as {name: string})?.name
                }
            });
        },
        options,
        name,
        value: options.filter((option) => (value as unknown as OptionType["value"][])?.includes(option.value))
    };
};

/**
 * @deprecated use util from package `@pg-mono/react-hook-forms-utils`
 */
export const useTransformReactHookFormToRadioProps = <CustomFieldValues extends Record<string, unknown>>(
    name: Path<CustomFieldValues>,
    register: UseFormRegister<CustomFieldValues>,
    watch: UseFormWatch<CustomFieldValues>,
    radioValue: string | boolean,
    setValue: UseFormSetValue<CustomFieldValues> // this would be better to set to generic however for some reason types on setValue are set to string, despite the fact it uses Path type
) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const {onBlur, ...registerProps} = register(name);
    const currentFormValue = watch(name); //this is returning current value of form. It will re-render all radio buttons connected to the same field updating their state;
    const isActive = currentFormValue === radioValue;

    return {
        ...registerProps,
        // eslint-disable-next-line  @typescript-eslint/no-explicit-any
        onChange: (name: Path<CustomFieldValues>, isChecked: boolean, value: any) => {
            const convertedValue = typeof radioValue === "boolean" ? "" : JSON.parse(value);

            /**
             * This is due to fact that clicking on input which is not the same as ref, correct value wont be registered and value will not be set when submitting.
             * Due to this fact setValue is used to set it programmatically. This is a ugly solution to avoid breaking radio button for other usages then use-react-hook ones.
             * Second reason is that by doing this we will only re render two inputs that are watching the same field value and not the whole form
             */
            setValue(name, convertedValue);

            registerProps.onChange({
                target: {
                    name,
                    value: radioValue
                }
            });
        },
        id: `${name}-${radioValue}`,
        name,
        isActive,
        value: radioValue as string
    };
};

/**
 * @deprecated use util from package `@pg-mono/react-hook-forms-utils`
 */
export const transformReactHookFormToTextAreaProps = (registerProps: UseFormRegisterReturn<string>) => {
    return {
        ...registerProps,
        onChange: (event: ChangeEvent<HTMLTextAreaElement>) => {
            registerProps.onChange(event);
        }
    };
};
